import React from 'react';

import Overview from 'react-scale/components/website/big/open-datasets/shared/Overview';
import AboutAutomoose from 'react-scale/components/website/big/open-datasets/waterloo/AboutAutomoose';
import ImagesGrid from 'react-scale/components/website/big/open-datasets/shared/ImagesGrid';
import DataCollection from 'react-scale/components/website/big/open-datasets/shared/DataCollection';
import CarSetup from 'react-scale/components/website/big/open-datasets/shared/CarSetup';
import InteractiveCar from 'react-scale/components/website/big/open-datasets/shared/InteractiveCar';
import TitleVideo from 'react-scale/components/website/big/open-datasets/shared/TitleVideo';
import SensorCalibration from 'react-scale/components/website/big/open-datasets/shared/SensorCalibration';
import DataAnnotation from 'react-scale/components/website/big/open-datasets/shared/DataAnnotation';
import BorderText from 'react-scale/components/website/big/open-datasets/shared/BorderText';
import InstancesPerLabel from 'react-scale/components/website/big/open-datasets/shared/InstancesPerLabel';
import GetStarted from 'react-scale/components/website/big/open-datasets/shared/GetStarted';

import { Header, Footer, Section, HeroBigWebGL } from 'react-scale/components';
import SceneViewer from 'react-scale/components/elements/scene-viewer';

import scenes from 'react-scale/components/website/big/open-datasets/waterloo/LidarScenes';

// react stateless functional component
const Waterloo = () => (
  <div className="relative bg-black">
    <div className="relative ">
      <Header
        title="Waterloo Open Datasets - Scale"
        canonical="https://scale.com/open-av-datasets/waterloo"
        favicon="open-datasets/waterloo"
        description="Open-source dataset for autonomous driving in wintry weather.Open-source dataset for autonomous driving in wintry weather."
        ogImg="https://scale.com/static/img/website/open-datasets/waterloo/social/fb.png"
        twImg="https://scale.com/static/img/website/open-datasets/waterloo/social/tw.png"
      />
      {/* <Navigation
      title={{
        text: 'Open Datasets',
        href: '/open-av-datasets'
      }}
      links={navigationLinks}
      theme="dark"
    /> */}
      <HeroBigWebGL
        title="Canadian Adverse Driving Conditions Dataset"
        subtitle="Open-source dataset for autonomous driving in wintry weather."
        webgl={{
          style: {
            '--gradient-color-1': '#FFD600',
            '--gradient-color-2': '#FFD600',
            '--gradient-color-3': '#000',
            '--gradient-color-4': '#000'
          }
        }}
        cta={{
          buttons: [
            {
              href: '/open-av-datasets/waterloo/download',
              text: 'Download Dataset',
              type: 'primary',
              variant: 'default'
            },
            { href: '/about', text: 'Learn More About Scale', type: 'secondary' }
          ]
        }}
      />
    </div>

    <Section bg="bg-black">
      <SceneViewer
        scenes={scenes}
        viewerTheme={{
          arrow: '#000000',
          color: '#000000',
          hover: '#FFD600'
        }}
        bgColor="#333333"
      />
    </Section>
    <div className="overflow-hidden text-white">
      <Overview
        icon={OverviewIcon}
        title="High quality data for adverse driving conditions"
        text={[
          'The CADC dataset aims to promote research to improve self-driving in adverse weather conditions. This is the first public dataset to focus on real world driving data in snowy weather conditions.',
          'It features:'
        ]}
        listItems="56,000 camera images; 7,000 LiDAR sweeps; 75 scenes of 50-100 frames each; 10 annotation classes; Full sensor suite: 1 LiDAR, 8 Cameras, Post-processed GPS/IMU; Adverse weather driving conditions, including snow"
        caseColor="#FFD600"
      >
        <AboutAutomoose />
      </Overview>
      <ImagesGrid
        images={[
          {
            src: '/static/img/website/open-datasets/waterloo/car-1.jpg',
            alt: 'a Waterloo car one driving on the snow'
          },
          {
            src: '/static/img/website/open-datasets/waterloo/car-2.jpg',
            alt: 'a Waterloo car two driving on the snow'
          }
        ]}
      />
      <DataCollection
        iconColors={['#FFFFFF', '#FFD600', '#FFE576']}
        title="Complex Driving Scenarios in Adverse Conditions"
        text={[
          'For this dataset, routes were chosen with various levels of traffic, a variety of vehicles and always with snowfall.',
          'Sequences were selected from data collected within the Region of Waterloo, Canada.'
        ]}
        caseColor="#FFD600"
        mapAssets={[
          {
            src: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d92638.88562930217!2d-80.61675923327745!3d43.482197125405804!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882bf1565ffe672b%3A0x5037b28c7231d90!2sWaterloo%2C%20ON%2C%20Canada!5e0!3m2!1sen!2sar!4v1579197737946!5m2!1sen!2sar',
            name: 'Waterloo'
          }
        ]}
        video={{
          canAutoplay: true,
          title: 'More on Autonomoose',
          url: 'https://stream.mux.com/XMtQoLsISiV7V01GZn4XdgIqV005B5j02wM.m3u8',
          poster:
            'https://image.mux.com/XMtQoLsISiV7V01GZn4XdgIqV005B5j02wM/thumbnail.png?width=1232&height=693&fit_mode=pad'
        }}
      />
      <CarSetup
        iconColors={['#FFD600', '#FFE576', '#FFFFFF']}
        text={[
          'We collected data using the Autonomoose, a Lincoln MKZ Hybrid mounted with a full suite of LiDAR, inertial and vision sensors.',
          'Please refer to the figure below for the sensor configuration of the Autonomoose.'
        ]}
        caseColor="#FFD600"
      >
        <InteractiveCar
          dataset="waterloo"
          items={[
            {
              type: 'wide-angle',
              text: 'Wide Angle Cameras',
              number: '8',
              background: '#FFD600',
              content: [
                '10 Hz capture frequency',
                '1/1.8” CMOS sensor of 1280x1024 resolution',
                'Images are stored as PNG'
              ]
            },
            {
              type: 'lidar',
              text: 'LiDAR',
              number: '1',
              background: '#FFD600',
              content: [
                '10 Hz capture frequency',
                '32 channels',
                '200m range',
                '360° horizontal FOV; 40° vertical FOV (-25° to +15°)'
              ]
            },
            {
              type: 'gps-imu',
              text: 'Post-processed GPS and IMU',
              number: '1',
              background: '#FFD600'
            }
          ]}
        />
      </CarSetup>
      <TitleVideo
        canAutoplay
        videoTitle="More on Autonomoose: The University of Waterloo's self-driving research platform."
        videoURL="https://stream.mux.com/veLqv1pbaOOeHZB1xPQihlZ8tdvcxKNo.m3u8"
        poster="https://image.mux.com/veLqv1pbaOOeHZB1xPQihlZ8tdvcxKNo/thumbnail.png?width=1232&height=693&fit_mode=pad"
        lineColor="#FFD600"
        videoProvider="mux"
        titleVariant="h1LG"
        titleColumns={{ xl: '1 / 12', lg: '1 / 13' }}
        backgroundHeight="26"
      />
      <SensorCalibration
        iconColors={['#FFD600', '#FFFFFF', '#FFE576']}
        dataset="waterloo"
        caseColor="#FFD600"
        sensorDetailsList={[
          {
            text: 'LiDAR extrinsics',
            type: 'lidar-hover'
          },
          {
            text: 'Camera extrinsics',
            type: 'camera-e-hover'
          },
          {
            text: 'Camera intrinsic calibration',
            type: 'camera-i-hover'
          },
          {
            text: 'IMU extrinsics',
            type: 'imu-hover'
          }
        ]}
      />
      <DataAnnotation
        activeItemColor="#FFD600"
        iconColors={['#FFD600', '#FFE576', '#FFD600', '#FFFFFF']}
        text={[
          'Scale’s data annotation platform combines human work and review with smart tools, statistical confidence checks and machine learning checks to ensure the quality of annotations.',
          'The resulting accuracy is consistently higher than what a human or synthetic labeling approach can achieve independently as measured against seven rigorous quality areas for each annotation.'
        ]}
        caseColor="#FFD600"
        scenes={scenes}
      />
      <BorderText
        borderColor="#FFD600"
        content={[
          'The resulting accuracy is consistently higher than what a human or synthetic labeling approach can achieve independently as measured against seven rigorous quality areas for each annotation.',
          'The CADC includes 3D Bounding boxes for X object classes and a rich set of class attributes related to X, Y. For detailed definitions of each class and example images, please see the annotation instructions.'
        ]}
      />
      <InstancesPerLabel items={instancesPerLabelItems} background="#FFD600" />
      <GetStarted
        title="Get Started with CADC Dataset"
        titleWidth={{
          xl: '400px',
          lg: '400px'
        }}
        datasetName="waterloo"
        background="#000000"
        cta={{
          href: '/open-av-datasets/waterloo/download',
          text: 'Download Dataset',
          colors: {
            bg: 'bg-utility-yellow',
            text: 'text-white'
          }
        }}
      >
        <p className="text-lg">
          View our paper{' '}
          <a href="https://arxiv.org/abs/2001.10117" target="_blank" rel="noopener noreferrer">
            here
          </a>{' '}
          and download the development kit.
        </p>
        <p className="mb-4 text-lg">If you use our dataset please cite our paper.</p>
      </GetStarted>
    </div>
    <Footer theme="dark" border />
  </div>
);

// const navigationLinks = [
//   {
//     text: 'Overview',
//     href: '#overview'
//   },
//   {
//     text: 'Data Collection',
//     href: '#data-collection'
//   },
//   {
//     text: 'Car Setup',
//     href: '#car-setup'
//   },
//   {
//     text: 'Sensor Calibration',
//     href: '#sensor-calibration'
//   },
//   {
//     text: 'Data Annotation',
//     href: '#data-annotation'
//   }
// ];

const instancesPerLabelItems = [
  {
    instances: '28194',
    label: 'Cars'
  },
  {
    instances: '62851',
    label: 'Pedestrians'
  },
  {
    instances: '20441',
    label: 'Trucks'
  },
  {
    instances: '4867',
    label: 'Bus'
  },
  {
    instances: '4808',
    label: 'Garbage Containers on Wheels'
  },
  {
    instances: '3205',
    label: 'Traffic Guidance Objects'
  },
  {
    instances: '705',
    label: 'Bicycle'
  },
  {
    instances: '638',
    label: 'Pedestrian With Object'
  },
  {
    instances: '75',
    label: 'Horse and Buggy'
  },
  {
    instances: '26',
    label: 'Animals'
  }
];

const OverviewIcon = (
  <svg viewBox="0 0 120 120">
    <path
      d="M60 120C93.1371 120 120 93.1371 120 60C120 26.8629 93.1371 0 60 0C26.8629 0 0 26.8629 0 60C0 93.1371 26.8629 120 60 120Z"
      fill="black"
    />
    <path
      d="M33.3327 66.6668C37.0146 66.6668 39.9993 63.6821 39.9993 60.0002C39.9993 56.3183 37.0146 53.3335 33.3327 53.3335C29.6508 53.3335 26.666 56.3183 26.666 60.0002C26.666 63.6821 29.6508 66.6668 33.3327 66.6668Z"
      fill="#FFE576"
    />
    <path
      d="M86.6667 66.6668C90.3486 66.6668 93.3333 63.6821 93.3333 60.0002C93.3333 56.3183 90.3486 53.3335 86.6667 53.3335C82.9848 53.3335 80 56.3183 80 60.0002C80 63.6821 82.9848 66.6668 86.6667 66.6668Z"
      fill="#FFE576"
    />
    <path
      d="M59.9987 93.3333C63.6806 93.3333 66.6654 90.3486 66.6654 86.6667C66.6654 82.9848 63.6806 80 59.9987 80C56.3168 80 53.332 82.9848 53.332 86.6667C53.332 90.3486 56.3168 93.3333 59.9987 93.3333Z"
      fill="#FFE576"
    />
    <path
      d="M59.9987 40.0001C63.6806 40.0001 66.6654 37.0153 66.6654 33.3334C66.6654 29.6515 63.6806 26.6667 59.9987 26.6667C56.3168 26.6667 53.332 29.6515 53.332 33.3334C53.332 37.0153 56.3168 40.0001 59.9987 40.0001Z"
      fill="#FFE576"
    />
    <path
      d="M83.8311 33.8214L33.8203 83.8181L36.177 86.1754L86.1878 36.1788L83.8311 33.8214Z"
      fill="#FFD600"
    />
    <path
      d="M34.9993 93.3334C39.6017 93.3334 43.3327 89.6025 43.3327 85.0001C43.3327 80.3977 39.6017 76.6667 34.9993 76.6667C30.397 76.6667 26.666 80.3977 26.666 85.0001C26.666 89.6025 30.397 93.3334 34.9993 93.3334Z"
      fill="#FFD600"
    />
    <path
      d="M34.9993 43.3334C39.6017 43.3334 43.3327 39.6025 43.3327 35.0001C43.3327 30.3977 39.6017 26.6667 34.9993 26.6667C30.397 26.6667 26.666 30.3977 26.666 35.0001C26.666 39.6025 30.397 43.3334 34.9993 43.3334Z"
      fill="white"
    />
    <path
      d="M59.9987 71.6668C66.442 71.6668 71.6654 66.4435 71.6654 60.0002C71.6654 53.5568 66.442 48.3335 59.9987 48.3335C53.5554 48.3335 48.332 53.5568 48.332 60.0002C48.332 66.4435 53.5554 71.6668 59.9987 71.6668Z"
      fill="white"
    />
    <path
      d="M84.9994 93.3334C89.6017 93.3334 93.3327 89.6025 93.3327 85.0001C93.3327 80.3977 89.6017 76.6667 84.9994 76.6667C80.397 76.6667 76.666 80.3977 76.666 85.0001C76.666 89.6025 80.397 93.3334 84.9994 93.3334Z"
      fill="white"
    />
    <path
      d="M84.9994 43.3334C89.6017 43.3334 93.3327 39.6025 93.3327 35.0001C93.3327 30.3977 89.6017 26.6667 84.9994 26.6667C80.397 26.6667 76.666 30.3977 76.666 35.0001C76.666 39.6025 80.397 43.3334 84.9994 43.3334Z"
      fill="#FFD600"
    />
  </svg>
);

export default Waterloo;
